import { createActionGroup, props } from '@ngrx/store';

export const VaButtonActions = createActionGroup({
  source: 'VaButton',
  events: {
    Minimize: props<{ isLiveChat: boolean; agentName: string }>(),
    'On Session Expired': props<{ popOverText: string }>(),
    'Update Unread Message Count': props<{
      agentName: string;
      unreadMessageCount: number;
    }>(),
    'Enable Or Disable Floating Button': props<{
      isFloatingButtonEnabled: boolean;
    }>(),
    'Set Button Text': props<{ buttonText: string }>(),
    'Set Minimized Header Title': props<{ minimizedHeaderTitle: string }>(),
    'Set logo Url': props<{ logoImageUrl: string }>(),
    'Set Chat App Brand': props<{ chatAppBrand: string }>(),
    'Set Proactive Chat': props<{ popOverText: string }>(),
  },
});
